import React from 'react';
import ToeicHero from '../components/toeic/ToeicHero/ToeicHero';
import ToeicPlacementTest from '../components/toeic/ToeicPlacementTest/ToeicPlacementTest';

/**
 * TOEIC page — hero and placement test.
 */
function ToeicPage() {
  return (
    <main>
      <ToeicHero />
      <ToeicPlacementTest />
    </main>
  );
}

export default ToeicPage;
